const HEALTH_ITEMS = [
  [1, "Skin problems", "皮肤问题", "skin_problem", "skin_details", "skin_contagious"],
  [2, "Body aches and pain", "肌肉酸痛", "body_aches", "body_aches_details"],
  [3, "Diarrhea and/or vomiting", "腹泻和/或呕吐", "diarrhea_vomiting", "diarrhea_vomiting_details"],
  [4, "Eye problems", "眼疾", "eye_problems", "eye_details"],
  [7, "Problems breathing or coughing", "呼吸或咳嗽问题", "breathing_problem", "breathing_details"],
  [8, "Blood problems", "血液问题", "blood_problem", "blood_details", "blood_contagious"],
  [9, "Fainting or blacking out", "昏厥", "fainting", "fainting_details"],
  [10, "Injuries", "伤痛/跌伤", "injuries", "injuries_details"],
  [11, "Mental illness", "心理或者精神疾病", "mental_illness", "mental_illness_details"],
  [12, "Any daily medicines?", "日常是否需要按时吃药？", "daily_medicines", "daily_medicines_details"],
  [13, "Other problems", "其它健康问题", "other_problem", "other_problem_details"],
];

const RELATIONSHIPS = {
  very_involved: "希望花很多时间与住家活动并了解美国生活",
  balanced: "偶尔与住家活动和用餐，同时保留独处时间",
  dinner_only: "参加日常晚餐，但不安排太多额外相处时间",
  mostly_private: "偶尔交流，大部分时间自己独处",
  private: "更喜欢独处，不希望安排住家活动",
};

const DEPARTMENT_ASSET_BASE = process.env.VUE_APP_DEPARTMENT_API_BASE_URL || (
  process.env.NODE_ENV === "development" ? "http://192.168.1.155:8093" : "https://pactapi.naaeus.com"
);

export function escapeHtml(value) {
  return String(value === null || value === undefined ? "" : value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
}

function display(value) {
  const text = Array.isArray(value) ? value.join("、") : value;
  return text === "" || text === null || text === undefined ? '<span class="print-empty">—</span>' : escapeHtml(text);
}

function choice(value) {
  return `<span class="print-choice ${value === "yes" ? "is-selected" : ""}">YES 是</span><span class="print-choice ${value === "no" ? "is-selected" : ""}">NO 否</span>`;
}

function checkbox(checked, label) {
  return `<span class="print-checkbox">${checked ? "☑" : "☐"} ${escapeHtml(label)}</span>`;
}

function safeImageSource(value) {
  const source = typeof value === "string" ? value : value && (value.url || value.path || value.file_path);
  if (!source) return "";
  if (/^data:image\/(png|jpe?g|webp);base64,/i.test(source)) return source;
  if (/^\/uploads\/department\//.test(source)) return `${DEPARTMENT_ASSET_BASE}${source}`;
  if (/^https:\/\/naae\.oss-cn-hangzhou\.aliyuncs\.com\/later\/family_photo\//i.test(source)) return source;
  return "";
}

function row(label, value) {
  return `<div class="print-field"><span class="print-field-label">${escapeHtml(label)}</span><span class="print-field-value">${display(value)}</span></div>`;
}

function signature(label, image, printName, date) {
  const source = safeImageSource(image);
  return `<div class="print-signature">
    <strong>${escapeHtml(label)}</strong>
    <div class="print-signature-image">${source ? `<img src="${source}" alt="${escapeHtml(label)}">` : '<span class="print-empty">未签名</span>'}</div>
    ${row("Print Name 姓名", printName)}
    ${row("Date 日期", date)}
  </div>`;
}

function healthQuestion(item, health) {
  const [number, en, zh, field, detailField, contagiousField] = item;
  const details = health[detailField];
  const contagious = contagiousField && health[field] === "yes"
    ? `<div class="print-subline"><span>Is it contagious? 是否传染</span>${choice(health[contagiousField])}</div>`
    : "";
  return `<div class="print-question">
    <div class="print-question-head"><span class="print-number">${number}</span><strong>${escapeHtml(en)}</strong><span>${escapeHtml(zh)}</span><span class="print-answer">${choice(health[field])}</span></div>
    <div class="print-detail"><span>Please state 请注明：</span>${display(details)}</div>
    ${contagious}
  </div>`;
}

function renderHealth(health = {}, title) {
  const orderedQuestions = [
    ...HEALTH_ITEMS.filter(item => item[0] <= 4),
    [5, "Do you have allergies?", "你有任何过敏史吗？", "allergies_status"],
    [6, "Internal organ problems", "内脏器官问题", "organ_problem"],
    ...HEALTH_ITEMS.filter(item => item[0] >= 7),
  ];
  const questions = orderedQuestions.map(item => {
    if (item[0] === 5) {
      return `<div class="print-question">
        <div class="print-question-head"><span class="print-number">5</span><strong>Do you have allergies?</strong><span>你有任何过敏史吗？</span><span class="print-answer">${choice(health.allergies_status)}</span></div>
        <div class="print-options">${["Food 食物", "Animals 动物", "Dust 粉尘", "Medicines 药物"].map(type => checkbox((health.allergy_types || []).includes(type), type)).join("")}</div>
        <div class="print-detail"><span>Others 其它：</span>${display(health.allergy_other)}</div>
      </div>`;
    }
    if (item[0] === 6) {
      return `<div class="print-question">
        <div class="print-question-head"><span class="print-number">6</span><strong>Internal organ problems</strong><span>内脏器官问题</span><span class="print-answer">${choice(health.organ_problem)}</span></div>
        <div class="print-options">${["Chest pain 胸痛", "Heart problems 心脏问题"].map(type => checkbox((health.organ_types || []).includes(type), type)).join("")}</div>
        <div class="print-detail"><span>Others 其它：</span>${display(health.organ_other)}</div>
      </div>`;
    }
    return healthQuestion(item, health);
  }).join("");

  return `<section class="print-sheet">
    <h1>Basic Health Survey</h1><h2>基本健康问卷</h2>
    <div class="print-meta">${row("Document 文件", title)}${row("Chinese Name 学生姓名", health.student_name)}${row("Gender 性别", health.gender)}${row("Year of Birth 出生年份", health.birth_year)}</div>
    <div class="print-section-title">Health Information 健康信息</div>
    ${questions}
    <div class="print-question print-no-illness">${checkbox(Boolean(health.no_physical_illness), "14. No physical illness 没有任何身体疾病")}</div>
    <div class="print-declaration">
      <p>I (${display(health.declaration_student_name)}) and the student's parents (${display(health.parent_names)}) promise that the student has no undisclosed infectious disease or major physical illness.</p>
      <p>本人（学生名字）及学生家长（家长名字）承诺所填信息真实完整，如有隐瞒，愿承担相应后果。</p>
    </div>
    <div class="print-signatures">${signature("Parent/Guardian Signature 家长签名", health.parent_signature, health.parent_print, health.parent_date)}${signature("Student Signature 学生签名", health.student_signature, health.student_print, health.student_date)}</div>
  </section>`;
}

function renderProfile(profile = {}, title) {
  const fields = [
    ["Chinese Name 中文姓名", profile.chinese_name], ["American Name 英文名", profile.american_name],
    ["First Name 名", profile.first_name], ["Last Name 姓", profile.last_name],
    ["Email 邮箱", profile.email], ["WeChat ID 微信号", profile.wechat_id],
    ["Date of Birth 出生日期", profile.date_of_birth], ["Gender 性别", profile.gender],
    ["Age 年龄", profile.age], ["Grade Entering 入读年级", profile.grade_entering],
    ["Mother 母亲", profile.mother_name], ["Father 父亲", profile.father_name],
    ["Parent/Agent Email 父母或代理人邮箱", profile.parent_agent_email], ["Parent/Agent WeChat 父母或代理人微信", profile.parent_agent_wechat],
    ["Hometown 家乡", profile.hometown], ["School 即将入读学校", profile.school],
    ["English Level 英语水平", profile.english_level], ["Host family children 是否愿意住家有孩子", profile.host_children],
    ["Host family relationship 期望住家关系", RELATIONSHIPS[profile.host_relationship] || profile.host_relationship],
    ["Smoking 吸烟", profile.smoke], ["Animal allergy 动物过敏", profile.animal_allergy],
    ["Allergies 其他过敏", profile.allergies], ["Food restrictions 食物禁忌", profile.food_restrictions],
    ["Medical/Psychological conditions 健康或心理问题", profile.medical_psychological_conditions],
  ];
  const photos = (profile.photos || []).map(photo => safeImageSource(photo)).filter(Boolean);
  return `<section class="print-sheet">
    <h1>STUDENT PROFILE</h1><h2>学生档案</h2>
    <div class="print-meta">${row("Document 文件", title)}</div>
    <div class="print-section-title">Student & Family Information 学生及家庭信息</div>
    <div class="print-field-grid">${fields.map(item => row(item[0], item[1])).join("")}</div>
    <div class="print-section-title">About the Student 关于学生</div>
    ${row("Hobbies 兴趣爱好", profile.hobbies)}
    ${row("Personality 性格特点", profile.personality)}
    <div class="print-long-field"><strong>Introduction 自我介绍</strong><p>${display(profile.introduction)}</p></div>
    <div class="print-section-title">Personal and Family Photos 个人和家庭照片</div>
    ${photos.length ? `<div class="print-photos">${photos.map((source, index) => `<figure><img src="${source}" alt="Photo ${index + 1}"><figcaption>Photo ${index + 1}</figcaption></figure>`).join("")}</div>` : '<div class="print-empty-block">未提供照片</div>'}
  </section>`;
}

export function renderDepartmentDocuments(payload = {}) {
  const docs = Array.isArray(payload.docs) ? payload.docs : String(payload.docs || "health,profile").split(",");
  const sections = [];
  if (docs.includes("health")) sections.push(renderHealth(payload.health || {}, payload.title));
  if (docs.includes("profile")) sections.push(renderProfile(payload.profile || {}, payload.title));
  return sections.join('<div class="print-page-break"></div>');
}
